import React from 'react';
import { Box } from '@mui/material';
import Header from '../../components/LandingPage/Header';
import Hero from './Hero';
import NewWay from './NewWay';
import Vantages from './Vantages';
import Cisp1 from './Cisp1';
import Acer from './Acer';
import HowItWorks from './HowItWorks';
import Signature from './Signature';
import Footer from '../../components/LandingPage/Footer';

const LandingPageLogin: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column">
      <Header />
      <Hero />
      <NewWay />
      <Vantages />
      <Cisp1 />
      <Acer />
      <HowItWorks />
      <Signature />
      {/* <BePartiner /> */}
      <Footer />
    </Box>
  );
};

export default LandingPageLogin;
